import type { AssetWorkflowOptions } from '../../types';

export const deactivateFulfillmentContextLinkPropertiesWorkflow: AssetWorkflowOptions = {
  workflowKey: 'deactivateFulfillmentContextLinkPropertiesWorkflow',
  workflowType: 'editAssetWorkflow',
  assetType: 'fulfillmentContextLinkProperty',
  workflowIndex: 1,
  deleteAction: true,
  workflowName: 'Deactivate Override',
  workflowDescription: `Deactivate an override you have configured.`,
  workflowStepOptions: [
    {
      workflowStepKey: `deactivate`,
      workflowStepNavigationName: `Remove Override?`,
      workflowComponent: {
        workflowComponentType: 'singleSelect',
        prompt: `Remove this override?`,
        description: `Removing the override will delete it.  To resume this behavior once it has been removed you must add a new override.`,
        help: ``,
        options: [
          { optionText: 'Yes, remove it', optionValue: true },
          { optionText: 'No, leave it in place', optionValue: false },
        ],
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Remove Override Summary',
        description: 'The following action will be taken.  Please review your selection.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
